module.exports = __webpack_public_path__ + "static/media/B1.3ea4e7bc.jpg";